module.exports = __webpack_public_path__ + "img/logo5.397fa93d.png";